import * as format from 'date-fns/format';
import * as isValid from 'date-fns/is_valid';
import * as parse from 'date-fns/parse';

export class DateUtil {
  static readonly MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

  static formatDate(date: any, formatStr = 'YYYY-MM-DD'): string {
    if (date !== null && isValid(new Date(date))) {
      return format(date, formatStr);
    } else {
      return '';
    }
  }

  static parseDate(date: string): Date {
    return parse(date);
  }

  static isValidDate(date: Date): boolean {
    return date instanceof Date && !isNaN(date.valueOf());
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/utils/date.util.ts